import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery4BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_4_bar"}/>
}
